// extracted by mini-css-extract-plugin
export default {"container":"GBtfboMp","desktop":"desktop","button":"w1VPYays","mobile":"mobile","buttonLink":"epvstVDj","buttonText":"g58wzr8e"};